import { useState } from "react";

import { Chip } from "@mui/material";

import { ReactComponent as MailIcon } from "_assets/icons/mail.svg";
import { ReactComponent as LockIcon } from "_assets/icons/lock.svg";

import Button from "_shared/Button";
import TextInput from "_shared/Input/Text";

//? React Router
// import { useNavigate } from "react-router-dom";

import { axios } from "setups/axios";

const Login = () => {
  const [data, setData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  // const navigate = useNavigate();

  const validate = () => {
    let error = "";

    if (!data.email || !data.password)
      error = "Please provide both Email and Password.";

    setError(error);

    if (error) return false;

    return true;
  };

  const loginHandler = async () => {
    if (!validate()) return;

    const res = await axios()({
      url: `/api/v1/login/master`,
      method: "POST",
      data,
    }).catch((error) => {
      console.log(error.response);

      setError(error?.response?.data?.message);

      return;
    });

    if (res) {
      const { data } = res.data;

      localStorage.setItem("token", data.token);

      location.reload();
      // navigate("/master/dashboard", { replace: true });
    }

    console.log(res?.data);
  };

  return (
    <>
      <Chip
        label="Master Dashboard"
        variant="outlined"
        sx={{
          color: "var(--primary)",
          borderColor: "var(--primary)",
        }}
      />
      <div className="login-container">
        {error && <div className="error-message">{error}</div>}

        <TextInput
          icon={<MailIcon />}
          placeholder="Email"
          value={data.email}
          setValue={(email) => setData({ ...data, email })}
        />

        <TextInput
          icon={<LockIcon />}
          type="password"
          placeholder="Password"
          value={data.password}
          setValue={(password) => setData({ ...data, password })}
        />

        <br />

        <Button text="Login" action={loginHandler} />
      </div>
    </>
  );
};

export default Login;
